import React from 'react';
import withStyles from '@mui/styles/withStyles';

import _ from 'lodash';

import { Grid } from '@mui/material';
import { FormControlLabel} from '@mui/material';
import { FormGroup } from '@mui/material';
import { FormControl } from '@mui/material';
import { Checkbox } from '@mui/material';
import { Typography } from '@mui/material';

import CustomTextField from './widgets/TextField';
import SelectField from './widgets/SelectField';

import SaveButton from '../ui/SaveButton';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 980,
    marginTop: 16
  },
  paper2: {
    padding: 12,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  }
});

class Form extends React.Component {
  style = {
    width: '100%',
  };

  constructor(props) {
    super(props);
    this.state = {
      timeout: null,
      index: 0,
    };
  }

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.values);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //if we updated, verify form can be saved.
    if (prevProps.values !== this.props.values) {
      if (this.props.setFormSaveDisabled) {
        this.props.setFormSaveDisabled(this.isFormSaveDisabled());
      }
    }
  }

  handleChange = (field, value) => {
    this.setChanges(field, value);
  };

  handleChangeCheckbox = (field, value) =>  {
    this.setChanges(field, value === true ? '1' : '0');
  }

  setChanges = (field, value) => {
    //not using state here, onChange to pass along values changes to parent.
    const values = { ...this.props.values, [field]: value };
    if (this.props.onChange) {
      this.props.onChange(values);
    }
  };

  getProperty = (key, defaultValue, formDefault) => {
    return _.get(this.props.values, key, defaultValue || formDefault);
  };

  getField = (field) => {
    const displayOnly = !this.props.saveForm && !this.props.preview;

    const key = field.key || field.name || 'key';
    const type = field.type || 'text';
    const defaultValue = field.default || null;
    const name = field.name || 'field';
    const disabled = displayOnly || field.disabled ||  false;
    const values = field.formDetailValuesTsByFormDetailId ? field.formDetailValuesTsByFormDetailId.values : field.values;


    if (displayOnly) {
      //everything displays typographically with "fieldName" as a title followed by the value or text
      let valueDisplay;
      switch(type) {
        case 'select':
          let theText = '';
          for (let i = 0; i < values.length; i++) {
            if (Number(this.getProperty(key, defaultValue, '')) === values[i].value) {
              theText = values[i].text;
              break;
            }
          }
          valueDisplay = <Typography variant='body2'>{theText}</Typography>;
          break;
        case 'checkbox':
          valueDisplay = <Typography variant='body2'>{Boolean(Number(this.getProperty(key, defaultValue, '0'))) ? 'Yes' : 'No'}</Typography>
          break;
        case 'password':
          //should this be displayed? or just ***? TBD later
        case 'text':
        case 'number':
        case 'multiLineText':
        default:
          valueDisplay = <Typography variant='body2'>{this.getProperty(key, defaultValue, '')}</Typography>;
      }

      return (
        <div>
          <Typography variant='body1' style={{ fontWeight:500 }}>{name}</Typography>
          {valueDisplay}
        </div>
      );
    } else {
      switch (type) {
        case 'text':
        case 'password':
        case 'number':
          return (
            <CustomTextField
              field={field}
              disabled={disabled}
              errors={this.props.errors}
              value={this.getProperty(key, defaultValue, '')}
              onChange={(event) => this.handleChange(key, event.target.value)}
            />
          );
  
        case 'multiLineText': {
          return (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
              >
                <CustomTextField
                  field={field}
                  disabled={disabled}
                  errors={this.props.errors}
                  value={this.getProperty(key, defaultValue, '')}
                  onChange={(event) => this.handleChange(key, event.target.value)}
                  multiline
                  maxRows={field.rowsMax || 3}
                />
                
              </div>
            </div>
          );
        }
  
        case 'select':
          return (
            <SelectField
              disableAction={disabled}
              field={field}
              value={this.getProperty(key, defaultValue, '')}
              options={values}
              errors={this.props.errors}
              onChange={(event) => this.handleChange(key, event.target.value)}
            />
          );
  
        case 'checkbox': {
          //checkbox is different, data true is saved 1, false is saved 0; translate this from string to num to boolean.
          //ALTERNATE, save to db as 'true'/'false' strings and parse as string with Boolean(value)
          let checkValue = Boolean(Number(this.getProperty(key, defaultValue, "0")));
  
          return (
            <FormControl component="fieldset">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkValue}
                      value={key}
                      onClick={(event) => {
                        this.handleChangeCheckbox(key, event.target.checked);
                      }}
                      disabled={disabled}
                    />
                  }
                  label={name}
                />
              </FormGroup>
            </FormControl>
          );
        }
  
        default: {
          return (<Typography>Unknown field</Typography>)
        }
      }
    }
  };

  getFields = () => {
    let isDisplayOnly = !this.props.saveForm;

    return this.props.fields.map((field, index) => (
      <Grid item xs={12} sm={isDisplayOnly || !field.qWidth ? 12 : field.qWidth}
        key={index}
        style={isDisplayOnly ? {marginTop: '8px'} : {marginTop: '16px'}}>
        {this.getField(field)}
      </Grid>
    ));
  }

  missingValues = () => {
    for (let i = 0; i < this.props.fields.length; i++) {
      let field = this.props.fields[i];
      const key = field.key || field.name || 'key';
      if (field.type === 'checkbox') {
        if (Boolean(field.optional) === true) {
          //optional fields can be empty
          continue;
        } else {
          //if not optional, must be "true"
          if (!Boolean(Number(this.getProperty(key, field.default || null, '0')))) {
            return true;
          }
        }
      } else {
        if (this.getProperty(key, '', '') === '') {
          if (Boolean(field.optional) === true) {
            //optional fields can be empty
            continue;
          } else {
            return true;
          }
        }
  
      }
    }

    //didn't find a missing field in "fields list", "false" to missing values.
    return false;
  }

  isFormSaveDisabled = () => {
    return this.missingValues() || _.isEqual(this.props.lastValues, this.props.values)
  }

  snackbarClose() {
    //can only influence the 'display' and 'duration' states here; other info is handled per vpp
    this.setState({
      saveFormSnackbarDuration: null, saveFormSnackbarOpen: false
    });
  }

  handleSave() {
    //in order to sequentially handle displaying some things, need to work with the promise from top-level vendorprogramform.js
    let thePromise = this.props.saveForm(); 

    if (!thePromise) {
      return;
    }

    thePromise.finally(() => {
      this.setState({
        saveFormSnackbarDuration: 3000,
        saveFormSnackbarOpen: true
      })
    });

    return thePromise;
  }

  render() {
    return (
      <Grid container spacing={1}>
        {this.getFields()}
        <Grid item xs={2} style={{marginTop: '16px'}}>
          {this.props.saveForm && (!this.props.isDialog && !this.props.preview) && (
            <SaveButton
              buttonType={'save'}
              iconMode="text"
              label="Save"
              variant="contained"
              autoHideDuration={this.state.saveFormSnackbarDuration}
              snackbarOpen={this.state.saveFormSnackbarOpen && (this.props.saveStatus === 'success' || this.props.saveStatus === 'error')}
              onSnackbarClose={() => { this.snackbarClose(); this.props.snackbarClose(); }}
              message={this.props.saveFormMessage}
              status={this.props.saveStatus}
              disabled={this.isFormSaveDisabled()}
              onSaveClick={() => {this.handleSave()}}
              style={{ display: 'block', margin: '0 auto', width: '30%' }}
            />
          )}
        </Grid>
      </Grid>

    );
  }
}

export default withStyles(styleSheet)(Form);